<template>
  <!-- ユーザ側表示部分 -->
  <div id="contents">
    <div class="company-area no-top">
      <h1
        v-if="photoClip.companyName"
        class="company-title"
        data-test="company-name"
      >
        {{ photoClip.companyName }}
      </h1>
    </div>
    <div class="contents-inner">
      <dl
        class="photoclip-block"
        data-test="photo-clip-block"
        :style="`background: url(${userCommonImageUrlForSp}/bg_stripe_gray.png) repeat top left;`"
      >
        <template v-for="(photoInfo, i) in photoClip.photoInfoList">
          <dt :key="`img-${i}`">
            <img
              v-if="photoInfo.image"
              :src="getPhotoUrl(photoInfo.image)"
              :data-test="`photo-${i}`"
              class="max-w100 image-height-auto"
            >
          </dt>
          <dd
            v-if="photoInfo.caption"
            :key="`caption-${i}`"
            class="pega-pre-wrap pega-break"
            :data-test="`caption-${i}`"
            v-text="photoInfo.caption"
          />
        </template>
      </dl>
    </div>

    <user-preview-menu-sp :titles="['募集情報', 'インタビュー']" />
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/photoclip/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import UserPreviewMenuSp from '@/components/atoms/UserPreviewMenuSp'
export default {
  components: { UserPreviewMenuSp },
  mixins: [jobPreviewCommon],
  props: {
    photoClip: {
      type: Object,
      required: true
    }
  }
}
</script>
